import { KeyboardEvent, useState } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";

import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchMonthSingleForm } from "src/components/common/form/search/SearchMonthSingleForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { formatDateMonth, formatDateYear4 } from "src/utils/string/stringUtil";
import { useEQM2040_R01Store } from "./Store_EQM2040_R01";

interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  onPrintClick: (inspectionType: string) => void;
}

export const SearchSection_EQM2040_R01 = ({ onEnterKeyDown, onPrintClick }: Props) => {

	const { EQM2040_R01Filter, setEQM2040_R01Filter } = useEQM2040_R01Store();
	const { compCdList, yesNoList } = useCommonCodeStore();
	
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

  return (
    <SearchSectionForm>
		<SearchDropDownForm
			label="사업장"
			value={EQM2040_R01Filter.compCd}
			optionList={compCdList}
			onChangeItem={(selectedItem) => setEQM2040_R01Filter({ compCd: selectedItem?.compCd || '' })}
		/>
		
		<SearchMonthSingleForm
				label="생산년월"
				visible={pickerVisible}		setVisible={setPickerVisible}
				value={new Date(EQM2040_R01Filter.inspectionMonth)}
				editable={true}
				onChange={(date) => setEQM2040_R01Filter({ inspectionMonth: formatDateYear4(date)+'-'+formatDateMonth(date) })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<button
				type="button"
				onClick={() => onPrintClick('LABORATORY')}
				className="flex-shrink-0 bg-white hover:bg-gray-100 border border-gray-300 text-gray-800 font-semibold px-4 rounded shadow h-[30px]"
			>
				실험실 출력
			</button>
			<button
				type="button"
				onClick={() => onPrintClick('PHARMACY')}
				className="flex-shrink-0 bg-white hover:bg-gray-100 border border-gray-300 text-gray-800 font-semibold px-4 rounded shadow h-[30px]"
			>
				약품실 출력
			</button>
			<button
				type="button"
				onClick={() => onPrintClick('X-RAY_ROOM')}
				className="flex-shrink-0 bg-white hover:bg-gray-100 border border-gray-300 text-gray-800 font-semibold px-4 rounded shadow h-[30px]"
			>
				X-Ray 출력
			</button>
	</SearchSectionForm>
  );
};